import { render, staticRenderFns } from "./DeferredScript.vue?vue&type=template&id=3f2c4221"
import script from "./DeferredScript.vue?vue&type=script&lang=ts"
export * from "./DeferredScript.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports